/**
 * @packageDocumentation
 * @module StockChartShared
 */
import {NgbDateAdapter, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';
import { toInteger, isNumber } from './stock-chart-util.service';

/**
 * This Service handles how the date is represented in scripts i.e. ngModel.
 */
@Injectable()
export class StockChartDateAdapterService extends NgbDateAdapter<string> {

  readonly DELIMITER = '-';

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
        const valueYear = value.substr(0, 4);
        const valueMonth = value.substr(4, 2);
        const valueDay = value.substr(6, 2);
        return {
            day: toInteger(valueDay),
            month: toInteger(valueMonth),
            year: toInteger(valueYear)
        };
      }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date ? date.year + '' + this.prefixZero(date.month) + '' + this.prefixZero(date.day) : null;
  }

  prefixZero(value) {
    return value < 10 ? '0' + value.toString() : value;
  }
}

